import React, { useState } from 'react';
import { Phone, MapPin, Instagram, Facebook } from 'lucide-react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [openModal, setOpenModal] = useState<null | 'privacy' | 'terms'>(null);
  return <footer className="bg-black border-t border-gold/20 pt-16 pb-8" data-id="element-190">
      <div className="container mx-auto px-4 md:px-6" data-id="element-191">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-192">
          {/* Logo & About */}
          <div className="space-y-6" data-id="element-193">
            <img src="https://cdn.magicpatterns.com/uploads/iQYanm8Z1ekmeHQEk8u1vc/logo2.png" alt="Celebrate Events Logo" className="h-20 w-auto" data-id="element-194" />
            <p className="text-cream/70 font-light text-sm max-w-xs" data-id="element-195">
              Cada evento cuenta una historia. Nosotros estamos aquí para
              capturarla. Lujo, elegancia y recuerdos eternos para la comunidad
              hispana.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-196">
            <h4 className="text-gold font-serif font-semibold text-lg mb-6" data-id="element-197">
              Enlaces Rápidos
            </h4>
            <ul className="space-y-3" data-id="element-198">
              <li data-id="element-199">
                <a href="#inicio" className="text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-200">
                  Inicio
                </a>
              </li>
              <li data-id="element-201">
                <a href="#servicio" className="text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-202">
                  El Servicio
                </a>
              </li>
              <li data-id="element-203">
                <a href="#testimonios" className="text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-204">
                  Testimonios
                </a>
              </li>
              <li data-id="element-205">
                <a href="#preguntas" className="text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-206">
                  Preguntas Frecuentes
                </a>
              </li>
              <li data-id="element-207">
                <a href="#reservar" className="text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-208">
                  Reservar Fecha
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-209">
            <h4 className="text-gold font-serif font-semibold text-lg mb-6" data-id="element-210">
              Contacto
            </h4>
            <ul className="space-y-4" data-id="element-211">
              <li data-id="element-212">
                <a href="tel:+14049409785" className="flex items-center gap-3 text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-213">
                  <Phone className="w-4 h-4" data-id="element-214" />
                  <span data-id="element-215">(404) 940-9785</span>
                </a>
              </li>
              <li data-id="element-216">
                <a href="tel:+16784721588" className="flex items-center gap-3 text-cream/70 hover:text-gold transition-colors text-sm" data-id="element-217">
                  <Phone className="w-4 h-4" data-id="element-218" />
                  <span data-id="element-219">(678) 472-1588</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-cream/70 text-sm" data-id="element-220">
                <MapPin className="w-4 h-4 shrink-0 mt-0.5" data-id="element-221" />
                <span data-id="element-222">Atlanta, GA y área metropolitana</span>
              </li>
              <li data-id="element-223">
                <a href="https://instagram.com/celebrateyp" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gold hover:text-gold-light transition-colors text-sm font-medium" data-id="element-224">
                  <Instagram className="w-4 h-4" data-id="element-225" />
                  <span data-id="element-226">@celebrateyp</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-227">
          <p className="text-cream/50 text-xs text-center md:text-left" data-id="element-228">
            © {new Date().getFullYear()} Celebrate Events · Atlanta, GA. Todos
            los derechos reservados.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs" data-id="element-229">
            <button onClick={() => setOpenModal('privacy')} className="text-cream/60 hover:text-gold transition-colors" data-id="element-230">
              Política de Privacidad
            </button>
            <span className="text-cream/20" data-id="element-231">·</span>
            <button onClick={() => setOpenModal('terms')} className="text-cream/60 hover:text-gold transition-colors" data-id="element-232">
              Términos y Condiciones
            </button>
          </div>

          <div className="flex items-center gap-4" data-id="element-233">
            <a href="https://instagram.com/celebrateyp" target="_blank" rel="noopener noreferrer" aria-label="Instagram @celebrateyp" className="text-gold hover:text-gold-light transition-colors hover:drop-shadow-[0_0_8px_rgba(212,175,55,0.6)]" data-id="element-234">
              <Instagram className="w-5 h-5" data-id="element-235" />
            </a>
            <a href="#" aria-label="Facebook" className="text-cream/50 hover:text-gold transition-colors" data-id="element-236">
              <Facebook className="w-5 h-5" data-id="element-237" />
            </a>
          </div>
        </div>
      </div>

      {/* Privacy Modal */}
      <LegalModal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-238">
        <p className="text-xs text-cream/50 uppercase tracking-wide" data-id="element-239">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-MX', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <p data-id="element-240">
          En <strong data-id="element-241">Celebrate Events</strong> valoramos profundamente tu
          privacidad y la confianza que depositas en nosotros al compartir tus
          datos personales. Esta política describe cómo recopilamos, usamos y
          protegemos tu información.
        </p>

        <h3 data-id="element-242">1. Información que recopilamos</h3>
        <p data-id="element-243">
          Cuando contactas con nosotros o reservas un evento, podemos solicitar:
        </p>
        <ul data-id="element-244">
          <li data-id="element-245">
            Nombre completo y datos de contacto (teléfono, correo electrónico).
          </li>
          <li data-id="element-246">
            Información del evento (fecha, ubicación, tipo de celebración).
          </li>
          <li data-id="element-247">
            Fotografías y contenido tomado durante el evento con nuestro Mirror
            Photo Booth.
          </li>
          <li data-id="element-248">Mensajes y comunicaciones que intercambies con nosotros.</li>
        </ul>

        <h3 data-id="element-249">2. Cómo usamos tu información</h3>
        <ul data-id="element-250">
          <li data-id="element-251">Para confirmar y coordinar la reserva de tu evento.</li>
          <li data-id="element-252">
            Para brindarte atención personalizada antes, durante y después del
            servicio.
          </li>
          <li data-id="element-253">
            Para enviarte una galería digital de las fotos tomadas en tu evento.
          </li>
          <li data-id="element-254">
            Para mejorar nuestros servicios y comunicarnos contigo sobre
            promociones (solo si lo autorizas).
          </li>
        </ul>

        <h3 data-id="element-255">3. Compartir información con terceros</h3>
        <p data-id="element-256">
          <strong data-id="element-257">Nunca vendemos ni alquilamos tus datos personales.</strong>{' '}
          Solo compartimos información cuando es estrictamente necesario para
          prestar el servicio (por ejemplo, con proveedores de impresión o
          almacenamiento de galerías), bajo estrictas obligaciones de
          confidencialidad.
        </p>

        <h3 data-id="element-258">4. Uso de fotografías</h3>
        <p data-id="element-259">
          Las fotografías tomadas en tu evento son tuyas y de tus invitados.
          Podríamos solicitar tu autorización por escrito para usar algunas de
          ellas en nuestro portafolio o redes sociales. Si no deseas que las
          usemos, simplemente avísanos y respetaremos tu decisión.
        </p>

        <h3 data-id="element-260">5. Seguridad de los datos</h3>
        <p data-id="element-261">
          Implementamos medidas técnicas y organizativas razonables para
          proteger tu información contra acceso no autorizado, pérdida o
          alteración.
        </p>

        <h3 data-id="element-262">6. Tus derechos</h3>
        <p data-id="element-263">
          Tienes derecho a acceder, rectificar o eliminar tus datos personales
          en cualquier momento. Para ejercer estos derechos, contáctanos al{' '}
          <a href="tel:+14049409785" data-id="element-264">(404) 940-9785</a>.
        </p>

        <h3 data-id="element-265">7. Cambios a esta política</h3>
        <p data-id="element-266">
          Podemos actualizar esta política ocasionalmente. La fecha de última
          actualización aparece al inicio del documento.
        </p>

        <h3 data-id="element-267">8. Contacto</h3>
        <p data-id="element-268">
          Si tienes preguntas sobre cómo manejamos tu información, escríbenos o
          llámanos. Estamos para servirte — en tu idioma, con respeto y
          transparencia.
        </p>
      </LegalModal>

      {/* Terms Modal */}
      <LegalModal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-269">
        <p className="text-xs text-cream/50 uppercase tracking-wide" data-id="element-270">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-MX', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <p data-id="element-271">
          Al contratar los servicios de <strong data-id="element-272">Celebrate Events</strong>,
          aceptas los siguientes términos y condiciones. Por favor léelos con
          atención.
        </p>

        <h3 data-id="element-273">1. Servicios</h3>
        <p data-id="element-274">
          Celebrate Events ofrece el alquiler del Mirror Photo Booth y servicios
          relacionados (instalación, atendente, impresión, diseño personalizado,
          fondo decorativo y galería digital) para eventos sociales y
          corporativos en el área metropolitana de Atlanta, GA.
        </p>

        <h3 data-id="element-275">2. Reserva de fecha</h3>
        <ul data-id="element-276">
          <li data-id="element-277">
            La fecha del evento se considera reservada únicamente al recibir el
            depósito acordado.
          </li>
          <li data-id="element-278">
            Recomendamos reservar con un mínimo de 4 a 8 semanas de
            anticipación.
          </li>
          <li data-id="element-279">
            Las fechas en temporada alta (mayo, junio, octubre y diciembre) se
            agotan rápido y se reservan por orden de llegada.
          </li>
        </ul>

        <h3 data-id="element-280">3. Pagos</h3>
        <ul data-id="element-281">
          <li data-id="element-282">
            Se requiere un depósito para asegurar la fecha. El monto se acuerda
            al firmar el contrato.
          </li>
          <li data-id="element-283">
            El saldo restante debe pagarse antes del inicio del evento, salvo
            acuerdo distinto.
          </li>
          <li data-id="element-284">Aceptamos efectivo, transferencia electrónica y Zelle.</li>
        </ul>

        <h3 data-id="element-285">4. Cancelaciones y reprogramaciones</h3>
        <ul data-id="element-286">
          <li data-id="element-287">
            Las cancelaciones realizadas con más de 30 días de anticipación
            pueden recibir reembolso parcial del depósito, sujeto a evaluación.
          </li>
          <li data-id="element-288">
            Las cancelaciones con menos de 30 días pierden el depósito por
            costos administrativos y de reserva.
          </li>
          <li data-id="element-289">
            Las reprogramaciones están sujetas a disponibilidad y se gestionan
            sin costo adicional cuando se solicitan con anticipación razonable.
          </li>
        </ul>

        <h3 data-id="element-290">5. Responsabilidades del cliente</h3>
        <ul data-id="element-291">
          <li data-id="element-292">
            Proveer un espacio adecuado para el espejo (mínimo recomendado: 3m x
            3m) con acceso a toma de corriente eléctrica.
          </li>
          <li data-id="element-293">
            Garantizar el trato respetuoso de nuestro equipo y atendente durante
            el evento.
          </li>
          <li data-id="element-294">
            Cubrir el costo de reparación o reposición en caso de daño causado
            por invitados al equipo.
          </li>
        </ul>

        <h3 data-id="element-295">6. Responsabilidades de Celebrate Events</h3>
        <ul data-id="element-296">
          <li data-id="element-297">
            Llegar a tiempo e instalar el equipo antes del inicio del evento.
          </li>
          <li data-id="element-298">
            Operar el espejo y asistir a los invitados durante toda la duración
            contratada.
          </li>
          <li data-id="element-299">
            Entregar fotos impresas de calidad profesional al instante,
            personalizadas con el nombre y fecha del evento.
          </li>
          <li data-id="element-300">
            Compartir la galería digital con el cliente dentro de los días
            posteriores al evento.
          </li>
        </ul>

        <h3 data-id="element-301">7. Limitación de responsabilidad</h3>
        <p data-id="element-302">
          Celebrate Events no se hace responsable por interrupciones causadas
          por fallas en el suministro eléctrico del lugar, condiciones
          climáticas extremas (en eventos al aire libre sin protección adecuada)
          o circunstancias fuera de nuestro control. En tales casos trabajaremos
          con el cliente para minimizar el impacto.
        </p>

        <h3 data-id="element-303">8. Uso de las fotografías</h3>
        <p data-id="element-304">
          Las fotos tomadas durante el evento pertenecen al cliente y sus
          invitados. Celebrate Events puede solicitar autorización para mostrar
          algunas en su portafolio o redes sociales. El cliente puede rechazar
          este uso sin penalización.
        </p>

        <h3 data-id="element-305">9. Modificaciones</h3>
        <p data-id="element-306">
          Estos términos pueden actualizarse en cualquier momento. La versión
          aplicable a tu evento será la vigente a la fecha de tu contrato.
        </p>

        <h3 data-id="element-307">10. Jurisdicción</h3>
        <p data-id="element-308">
          Cualquier controversia se resolverá conforme a las leyes del estado de
          Georgia, EE. UU.
        </p>

        <h3 data-id="element-309">11. Contacto</h3>
        <p data-id="element-310">
          Para cualquier duda relacionada con estos términos, comunícate al{' '}
          <a href="tel:+14049409785" data-id="element-311">(404) 940-9785</a> o{' '}
          <a href="tel:+16784721588" data-id="element-312">(678) 472-1588</a>.
        </p>
      </LegalModal>
    </footer>;
}